import classNames from 'classnames'
import { Link } from '~/components/Link'
import { GoogleReCaptchaNoticeProps } from './GoogleReCaptchaNotice.types'

const GoogleReCaptchaNotice = ({ className }: GoogleReCaptchaNoticeProps) => {
  return (
    <div
      className={classNames('text-xs text-gray-400 cursor-default', className)}>
      This site is protected by reCAPTCHA and the Google{' '}
      <Link
        target='_blank'
        className='text-sky-400'
        href='https://policies.google.com/privacy'>
        Privacy Policy
      </Link>{' '}
      and{' '}
      <Link
        target='_blank'
        className='text-sky-400'
        href='https://policies.google.com/terms'>
        Terms of Service
      </Link>{' '}
      apply.
    </div>
  )
}

export default GoogleReCaptchaNotice
